import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "47",
      height: "47",
      x: "47.5",
      y: "47.5",
      stroke: "currentColor",
      rx: "23.5",
      transform: "rotate(-180 47.5 47.5)"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 27.439q-.233 0-.437-.073a1 1 0 0 1-.38-.248l-5.366-5.367a1.1 1.1 0 0 1-.32-.817q0-.495.32-.816t.817-.321.816.32l4.55 4.55 4.55-4.55q.32-.32.817-.32.495 0 .817.32.32.322.32.817t-.32.817l-5.367 5.367q-.175.174-.38.248a1.3 1.3 0 0 1-.437.073"
    }, null, -1)
  ])))
}
export default { render: render }